import styles from "./MobMenu.module.scss";
import Srcset from "@/components/common/Srcset";
import ReactSidebar from "@/components/common/ReactSidebar";
import SubMenu from "../SubMenu";
import { useState, useEffect } from "react";
import MobileSubmenu from "./MobileSubmenu";
import { navigationTracking } from "@/components/common/Tracking";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/compat/router";
import { isPwaSubmenuVisible } from "@/redux/actions/headerAction";

export default function MobileNavigation({ menuItems, ...props }) {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const router = useRouter();
  const dispatch=useDispatch();

  return (
    <ul className={`${styles.mob_navigation_menu} ${isPWA && styles.pwa_search} ${styles.main_menu_list} main_menu_list_mobile`}>
      {menuItems.map((menuItem, index) => {
        return (
          <li key={index}>
            {/* <a className="small-sm small-xs" href={menuItem.navigationLink} onClick={() => navigationTracking("Navigation " + menuItem.navigationTitle)}>
                  {menuItem.navigationTitle}
            </a> */}
                  <ReactSidebar
                    mainContent={<div data-ga4={"Navigation " + menuItem.navigationTitle} className={styles.nav_block} onClick={(e) => {
                      // if subMenuColumns is present then show the submenu
                      // else navigate to the link
                      if(menuItem.subMenuColumns?.length > 0) {
                        dispatch(isPwaSubmenuVisible(true))
                      } else {
                        // stoppropagation is used to stop the event from bubbling up the DOM tree
                        e.stopPropagation()
                        window.location.href = menuItem.navigationLink
                      }
                    }}>
                    <span className="x-small">{menuItem.navigationTitle}</span>
                    <span className={`${styles.right_arrow}`}>
                              <Srcset
                                height="30"
                                width="20"
                                alt="Arrow Right"
                                requirePath={true}
                                svgFile={true}
                                src={"images/Icons/Arrow/Right/large.svg"}
                              />
                            </span>
                            </div>
                    }
                    secondaryContent={
                      <MobileSubmenu menuItems={menuItems} index={index}/>
                    }
                    sidebarContent={
                      <div className={`${styles.mob_main_menu}`}>                 
                        {menuItem.subMenuColumns && (
                          <SubMenu subMenu={menuItem.subMenuColumns} navigationTitle = {menuItem.navigationTitle} />
                        )}
                      </div>
                    }
                    styles={{
                      root: {
                        position: "relative",
                        height: 33,
                        // width: 50,
                      },
                      sidebar: {
                        position: "fixed",
                        overflow: "hidden !important",
                        width: "100%",
                      },
                    }}
                    pullRight={false}
                  />
             
          </li>
        );
      })}
    </ul>
  );
}
